export type AddNewServiceCardForm = {
  cardDetails?: {
    cardNumber: string;
    expiryDate: string;
  };
  selectedCardId?: string;
};

export const initialAddNewServiceCardForm = {
  cardDetails: {},
  selectedCardId: undefined,
};
